import { formatCurrency } from '@/lib/utils';

// Zero means "nothing yet" (prospects, no paid invoices, no installed sensors), not missing data:
// show a dash rather than "$0" / "0".
export const formatArr = (amount: number | null | undefined) => (amount ? formatCurrency(amount, 'CAD', 0) : '—');
export const formatSensors = (count: number | null | undefined) => (count ? String(count) : '—');
